<template>
  <dialog-add
    class="tracking-edit-program-dialog"
    icon="link"
    :title="$t('edit_program')"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
  >
    <template v-slot:content>
      <forms-tracking-program
        :on-cancel="onCancel"
        @saved="$emit('saved')"
        :confirm-trigger-label="$t('edit_program')"
        class="elevation-1"
      />
    </template>
  </dialog-add>
</template>

<script>
export default {
  emits: ['saved'],
  methods: {
    onCancel() {
      this.$router.push({
        name: 'tracking-management-advertiser',
        params: { id: this.$route.params.id },
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss">
.tracking-edit-program-dialog {
  .dialog.add-item-dialog > .modal__backdrop > .modal__content {
    width: 692px;
  }
}
</style>
